<h1 mat-dialog-title>{{tituloDialog}}</h1>
<form>
  <div mat-dialog-content class="calibrates-theme">

    <div fxLayout="row" class="flexwrap">
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'internalEquipmentEdit.multichannels.values.name.label' | translate }}</mat-label>
          <input matInput [(ngModel)]="data.multichannel.description" name="description" required>
          <mat-error>
            {{ 'internalEquipmentEdit.multichannels.values.name.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-checkbox name="active" [(ngModel)]="data.multichannel.active">
          {{  (data.multichannel.active ? 'internalEquipmentEdit.multichannels.values.askDesactive.label' :'internalEquipmentEdit.multichannels.values.askActive.label') | translate }}
        </mat-checkbox>
      </div>
    </div>

    @if (showReason()) {
      <div fxLayout="column" class="flexwrap">
        <div fxFlex>
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentEdit.multichannels.values.reason.label' | translate }}</mat-label>
            <textarea matInput name="reasonChange" [(ngModel)]="data.multichannel.reasonActive" required>
              <mat-error>
                {{ 'common.reasonChangeError' | translate }}
              </mat-error>
            </textarea>
          </mat-form-field>
        </div>
      </div>
    }
  </div>
  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>